package er.prateek.crossly.content

import er.prateek.crossly.data.model.DifficultyTier
import er.prateek.crossly.data.model.Puzzle
import er.prateek.crossly.generation.TierGenerator
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

/**
 * Runtime wrapper around [TierGenerator].
 *
 * **Not on the startup path.** Filling a tier is a backtracking search costing
 * seconds, and the home screen totals every tier's levels, so generating on
 * demand put ~120 puzzle searches between the user and the first screen.
 * Levels are pre-generated into bundled packs by the `generatePuzzlePacks`
 * Gradle task instead; see `tools/wordbank/README.md`.
 *
 * This is kept for tests and for the option of generating extra levels beyond
 * the bundled set at runtime -- never as the default source.
 */
class GeneratedPuzzleSource(
    private val wordBankSource: WordBankSource = WordBankSource(),
    private val puzzlesPerTier: Int = 30,
) {
    private val cache = mutableMapOf<DifficultyTier, List<Puzzle>>()

    suspend fun puzzlesFor(tier: DifficultyTier, startIndex: Int = 1): List<Puzzle> {
        cache[tier]?.let { return it }
        val bank = wordBankSource.load()
        return withContext(Dispatchers.Default) {
            TierGenerator(bank, puzzlesPerTier).generateTier(tier, startIndex)
        }.also { cache[tier] = it }
    }
}
